// The Rule newsletter embed renders an invisible reCAPTCHA; its script is loaded only once someone uses the form.
(() => {
  const container = document.querySelector('[data-recaptcha-src]');
  const form = container && container.querySelector('form');
  if (!form) {
    return;
  }

  let loading = null;
  const load = () => {
    if (!loading) {
      loading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = container.dataset.recaptchaSrc;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    return loading;
  };

  // The embed's onloadCallback renders the widget and sets the global widgetId some time after the script loads.
  const isReady = () => window.grecaptcha && typeof window.widgetId === 'number';
  const whenReady = () => new Promise((resolve) => {
    const started = Date.now();
    const check = () => (isReady() || Date.now() - started > 10000 ? resolve() : setTimeout(check, 100));
    check();
  });

  const preload = () => load().catch(() => {});
  form.addEventListener('focusin', preload, { once: true });
  form.addEventListener('pointerdown', preload, { once: true });

  // The embed's own submit handler calls grecaptcha.execute straight away, so hold the submit until it is ready.
  // After one wait the submit is handed to the embed whatever the state.
  let held = false;
  document.addEventListener('submit', (e) => {
    if (e.target !== form || isReady() || held) {
      return;
    }
    held = true;
    e.preventDefault();
    e.stopImmediatePropagation();
    load().then(whenReady, whenReady).then(() => {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }, true);
})();
